// DELETE FILE http://go/j/FUI-1091
import {
	type RenderState,
	type Handler,
	type ForgeDoc,
	type ExtensionConfiguration,
} from './forge';

export interface LegacyBackendRuntimePayload {
	config?: ExtensionConfiguration;
	context: Record<string, any>;
	contextToken?: string;
	effects: LegacyBackendEffect[];
	state: RenderState;
}
interface LegacyBaseEffect {
	type: string;
}

export interface LegacyInitializeEffect extends LegacyBaseEffect {
	type: 'initialize';
}
export interface LegacyEventEffect extends LegacyBaseEffect {
	args: any[];
	handler: Handler;
	type: 'event';
}

export interface LegacyActionEffect extends LegacyBaseEffect {
	componentKey: string;
	hookIndex: number;
	payload?: any;
	type: 'action';
}

export interface LegacyRenderEffect extends LegacyBaseEffect {
	aux: ForgeDoc;
	state: RenderState;
	type: 'render';
}

export type LegacyBackendEffect = LegacyInitializeEffect | LegacyActionEffect | LegacyEventEffect;

export type LegacyClientEffect = LegacyRenderEffect;
export type LegacyEffect = LegacyBackendEffect | LegacyClientEffect;

export const isLegacyInitializeEffect = (
	effect: LegacyEffect,
): effect is LegacyInitializeEffect => {
	return effect.type === 'initialize';
};

export const isLegacyActionEffect = (effect: LegacyEffect): effect is LegacyActionEffect => {
	return effect.type === 'action';
};

export const isLegacyEventEffect = (effect: LegacyEffect): effect is LegacyEventEffect => {
	return effect.type === 'event';
};

export const isLegacyRenderEffect = (effect: LegacyEffect): effect is LegacyRenderEffect => {
	return effect.type === 'render';
};

export function isLegacyBackendEffect(effect: LegacyEffect): effect is LegacyBackendEffect {
	return (
		isLegacyInitializeEffect(effect) || isLegacyActionEffect(effect) || isLegacyEventEffect(effect)
	);
}
